// removed by extract-text-webpack-plugin
module.exports = {"fieldset":"hh_hi","field":"hh_hj","questionSet":"hh_hk","questionSetTextarea":"hh_hl hh_hk","label":"hh_g8","helperText":"hh_hm","text":"hh_fs","textarea":"hh_hn","select":"hh_ho","counter":"hh_hp"};


//////////////////
// WEBPACK FOOTER
// ./app/src/base-styles/forms.module.css
// module id = 201
// module chunks = 27